import React from 'react';
import NotesIcon from '@mui/icons-material/Notes';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CollectionsIcon from '@mui/icons-material/Collections';
import QuizIcon from '@mui/icons-material/Quiz';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import LinkIcon from '@mui/icons-material/Link';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { TipoSecaoPaginaCustomizada } from '../../../../model/apm/apm-enums';

export const CUSTOM_PAGE_SECTION_ICONS: Record<TipoSecaoPaginaCustomizada, React.ReactElement> = {
    [TipoSecaoPaginaCustomizada.TextoLivre]: <NotesIcon />,
    [TipoSecaoPaginaCustomizada.ListaItens]: <FormatListBulletedIcon />,
    [TipoSecaoPaginaCustomizada.GaleriaImagens]: <CollectionsIcon />,
    [TipoSecaoPaginaCustomizada.Faq]: <QuizIcon />,
    [TipoSecaoPaginaCustomizada.ConteudoMisto]: <DashboardIcon />,
    [TipoSecaoPaginaCustomizada.VideoEmbed]: <SmartDisplayIcon />,
    [TipoSecaoPaginaCustomizada.ListaLinks]: <LinkIcon />,
    [TipoSecaoPaginaCustomizada.Documentos]: <FolderOpenIcon />,
};
